import { render, staticRenderFns } from "./trade-record.vue?vue&type=template&id=1f044e12&scoped=true"
import script from "./trade-record.vue?vue&type=script&lang=js"
export * from "./trade-record.vue?vue&type=script&lang=js"
import style0 from "./trade-record.vue?vue&type=style&index=0&id=1f044e12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f044e12",
  null
  
)

export default component.exports